import { render, staticRenderFns } from "./LeaderBoardStat.vue?vue&type=template&id=a604cfc0&scoped=true"
import script from "./LeaderBoardStat.vue?vue&type=script&lang=js"
export * from "./LeaderBoardStat.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardStat.vue?vue&type=style&index=0&id=a604cfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a604cfc0",
  null
  
)

export default component.exports